import { render, staticRenderFns } from "./SalaryDefaultCreate.vue?vue&type=template&id=17ad07f6&scoped=true"
import script from "./SalaryDefaultCreate.vue?vue&type=script&lang=js"
export * from "./SalaryDefaultCreate.vue?vue&type=script&lang=js"
import style0 from "./SalaryDefaultCreate.vue?vue&type=style&index=0&id=17ad07f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ad07f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17ad07f6')) {
      api.createRecord('17ad07f6', component.options)
    } else {
      api.reload('17ad07f6', component.options)
    }
    module.hot.accept("./SalaryDefaultCreate.vue?vue&type=template&id=17ad07f6&scoped=true", function () {
      api.rerender('17ad07f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/SalaryDefaultCreate.vue"
export default component.exports